export default __webpack_public_path__ + "static/media/logo-extended.a63a0c13.png";